/**
 * Created with JetBrains WebStorm.
 * User: bastienrobinot
 * Date: 11/05/2018
 * Time: 18h01
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('CustomerPostView', ["$filter", "CustomerPost", "CustomerPostData", "CustomerPostSrv", "CustomerData", "CompanyImageData", "MobileDeviceData",
    function ($filter, CustomerPost, CustomerPostData, CustomerPostSrv, CustomerData, CompanyImageData, MobileDeviceData) {

        var CustomerPostView = function (customerPost, cpIndex) {
            this.cpIndex = cpIndex;
            this.companyImage = null,
                this.customer = null,
                this.fromDevice = null,
                this.rating = null,
                this.customerAuthPublish = false,
                this.proAuthPublish = false,
                this.timeCreated = null,
                this.timePublished = null,
                this.text = "",
                this.title = "",
                this.loadDataFrom(customerPost);
        };
        CustomerPostView.prototype.getModel = function () {
            if (this.cpIndex != -1)
                return CustomerPostData.getByIndex(this.cpIndex);
            return null;
        }
        CustomerPostView.prototype.loadDataFrom = function (customerPost) {
            if (customerPost !== undefined && customerPost) {
                var customer = CustomerData.getById(customerPost.customerId)
                if (customer)
                    this.customer = customer;

                var companyImage = CompanyImageData.getById(customerPost.companyImageId)
                if (companyImage)
                    this.companyImage = companyImage;

                var fromDevice = MobileDeviceData.getById(customerPost.fromDeviceId)
                if (fromDevice)
                    this.fromDevice = fromDevice;

                this.rating = customerPost.rating;
                this.customerAuthPublish = customerPost.customerAuthPublish;
                this.proAuthPublish = customerPost.proAuthPublish;
                this.timeCreated = customerPost.timeCreated;
                this.timePublished = customerPost.timePublished;
                this.text = customerPost.text;
                this.title = customerPost.title;
            }
        }
        CustomerPostView.prototype.copyDataTo = function (customerPost) {

            if (this.companyImage)
                customerPost.companyImageId = this.companyImage.id;
            if (this.fromDevice)
                customerPost.fromDeviceId = this.fromDevice.getModel().id;
            if (this.customer)
                customerPost.customerId = this.customer.id;
            customerPost.rating = this.rating;
            customerPost.customerAuthPublish = this.customerAuthPublish;
            customerPost.proAuthPublish = this.proAuthPublish;
            customerPost.timeCreated = this.timeCreated;
            customerPost.timePublished = this.timePublished;
            customerPost.text = this.text;
            customerPost.title = this.title;
        }

        CustomerPostView.prototype.isChanged = function () {
            var customerPost = this.getModel();
            if (customerPost)
                return (
                    this.companyImage != customerPost.companyImage ||
                    this.customer != customerPost.customer ||
                    this.fromDevice != customerPost.fromDevice ||
                    this.rating != customerPost.rating ||
                    this.customerAuthPublish != customerPost.customerAuthPublish ||
                    this.proAuthPublish != customerPost.proAuthPublish ||
                    this.timePublished != customerPost.timePublished ||
                    this.text != customerPost.text ||
                    this.title != customerPost.title
                );
            else
                return true;
        };

        CustomerPostView.prototype.removeModel = function () {
            var customerPost = this.getModel();
            if (customerPost != null)
                CustomerPostSrv.remove(customerPost);
        }
        CustomerPostView.prototype.reloadModel = function () {
            var customerPost = this.getModel();
            if (customerPost != null)
                this.loadDataFrom(customerPost);

        }
        CustomerPostView.prototype.updateModel = function (endFunction) {
            //Save by default
            var customerPost = this.getModel();
            if (!customerPost)//create it
            {
                customerPost = new CustomerPost();
                this.cpIndex = CustomerPostData.getIndexOf(customerPost);
            }
            this.text = this.text.replace(new RegExp('<br/>', 'g'), '\n');
            this.copyDataTo(customerPost);
            CustomerPostSrv.save(customerPost, endFunction);

        }
        CustomerPostView.prototype.restoreModel = function () {
            var customerPost = this.getModel();
            if (customerPost)
                CustomerPostSrv.restore(customerPost);
        }
        CustomerPostView.prototype.canSave = function () {
            return true;
        }


        return CustomerPostView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/CustomerPostView.js